import { userHeaders } from '../../../constant/gms-constant'

export default function UserListThead() {
    return (
        <thead className="sticky top-0 z-20">
            <tr className="border-b border-[#145d99] bg-[#186cb2]">
                {userHeaders.map((header, index) => (
                    <th key={index} className='border-r border-white/10 px-3 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-white sm:px-4 sm:text-[11px]'>
                        {header}
                    </th>
                ))}
            </tr>
        </thead>
    )
}